// extracted by mini-css-extract-plugin
module.exports = {"alert":"index__alert___1gwm9","warning":"index__warning___nWgzC","content":"index__content___1Rasq","modal":"index__modal___3yvy5"};